<div class="recap-card">

  @if (displayData) {

    <!-- ── Section : Informations Générales ── -->
    <div class="recap-section">
      <div class="recap-section__header">
        <span class="recap-section__icon material-icons">info</span>
        <h4 class="recap-section__title">Informations Générales</h4>
      </div>
      <div class="recap-grid">
        <div class="recap-item">
          <span class="recap-item__label">Type d'intervention</span>
          <span class="recap-item__value">{{ interventionParent?.titre || '—' }}</span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Nom de l'activité</span>
          <span class="recap-item__value">{{ displayData.generales?.activities || '—' }}</span>
        </div>
        <div class="recap-item recap-item--full">
          <span class="recap-item__label">Description</span>
          <span class="recap-item__value">{{ displayData.generales?.description || '—' }}</span>
        </div>
        @if (displayData.generales?.programme) {
          <div class="recap-item">
            <span class="recap-item__label">Programme</span>
            <span class="recap-item__value">{{ displayData.generales.programme.titre }}</span>
          </div>
        }
        @if (displayData.generales?.objectif) {
          <div class="recap-item">
            <span class="recap-item__label">Objectif</span>
            <span class="recap-item__value">{{ displayData.generales.objectif.titre }}</span>
          </div>
        }
        <div class="recap-item">
          <span class="recap-item__label">Date de début</span>
          <span class="recap-item__value recap-item__value--date">
            <span class="material-icons recap-item__date-icon">calendar_today</span>
            {{ displayData.generales?.dateDebut | date:'dd/MM/yyyy' }}
          </span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Date de fin</span>
          <span class="recap-item__value recap-item__value--date">
            <span class="material-icons recap-item__date-icon">event</span>
            {{ displayData.generales?.dateFin | date:'dd/MM/yyyy' }}
          </span>
        </div>
      </div>

      <!-- Tâches -->
      @if (displayData.generales?.taches && displayData.generales.taches.length > 0) {
        <div class="taches-block">
          <h5 class="taches-block__title">
            <span class="material-icons">assignment</span>
            Tâches
          </h5>
          <div class="taches-list">
            @for (tache of displayData.generales.taches; track $index) {
              <div class="tache-item">
                <div class="tache-item__header">
                  <span class="tache-item__num">{{ $index + 1 }}</span>
                  <span class="tache-item__title">{{ tache.titreTache }}</span>
                  <span class="tache-item__poids">Poids : {{ tache.poids }}</span>
                </div>
                @if (tache.chronogrammes) {
                  <div class="tache-item__months">
                    @for (monthScheduled of tache.chronogrammes; track $index) {
                      @if (monthScheduled) {
                        <span class="month-badge">
                          {{ ['Jan','Fév','Mar','Avr','Mai','Jun','Jul','Aoû','Sep','Oct','Nov','Déc'][$index] }}
                        </span>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>

    <!-- ── Section : Informations sur l'Activité ── -->
    <div class="recap-section">
      <div class="recap-section__header">
        <span class="recap-section__icon material-icons">settings</span>
        <h4 class="recap-section__title">Informations sur l'Activité</h4>
      </div>
      <div class="recap-grid">
        <div class="recap-item">
          <span class="recap-item__label">Superviseur</span>
          <span class="recap-item__value">{{ displayData.activites?.supervisor || '—' }}</span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Mode d'exécution</span>
          <span class="recap-item__value">{{ displayData.activites?.modeExecution || '—' }}</span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Structure responsable</span>
          <span class="recap-item__value">{{ displayData.activites?.structureResponsable || '—' }}</span>
        </div>
        @if (displayData.activites?.structureAssociee?.length > 0) {
          <div class="recap-item recap-item--full">
            <span class="recap-item__label">Structures associées</span>
            <div class="tag-list">
              @for (structure of displayData.activites.structureAssociee; track $index) {
                <span class="tag">{{ structure }}</span>
              }
            </div>
          </div>
        }
      </div>
    </div>

    <!-- ── Section : Budget ── -->
    <div class="recap-section">
      <div class="recap-section__header">
        <span class="recap-section__icon material-icons">account_balance_wallet</span>
        <h4 class="recap-section__title">Budget</h4>
      </div>
      <div class="recap-grid">
        <div class="recap-item">
          <span class="recap-item__label">Montant encaissé estimatif</span>
          <span class="recap-item__value recap-item__value--money">{{ displayData.budgets?.EncaissementEstimatif || '—' }}</span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Montant décaissé estimatif</span>
          <span class="recap-item__value recap-item__value--money">{{ displayData.budgets?.DecaissementEstimatif || '—' }}</span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Imputation budgétaire</span>
          <span class="recap-item__value">{{ displayData.budgets?.imputationBudgetaire || '—' }}</span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Horizon</span>
          <span class="recap-item__value">{{ displayData.budgets?.horizon || '—' }}</span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Prévision N+1</span>
          <span class="recap-item__value recap-item__value--money">{{ displayData.budgets?.coutPrevuN1 || '—' }}</span>
        </div>
        <div class="recap-item">
          <span class="recap-item__label">Prévision N+2</span>
          <span class="recap-item__value recap-item__value--money">{{ displayData.budgets?.previsionDecaissementN2 || '—' }}</span>
        </div>
      </div>
    </div>

    <!-- ── Section : Informations Marché (PMP, conditionnelle) ── -->
    @if (displayData.stepfour?.datePrevision) {
      <div class="recap-section recap-section--pmp">
        <div class="recap-section__header">
          <span class="recap-section__icon material-icons" style="color:#8b5cf6">gavel</span>
          <h4 class="recap-section__title">Informations Marché (PMP)</h4>
          <span class="pmp-badge">PMP</span>
        </div>
        <div class="recap-grid">
          <div class="recap-item">
            <span class="recap-item__label">Date de prévision</span>
            <span class="recap-item__value recap-item__value--date">
              <span class="material-icons recap-item__date-icon">calendar_today</span>
              {{ displayData.stepfour?.datePrevision | date:'dd/MM/yyyy' }}
            </span>
          </div>
          <div class="recap-item">
            <span class="recap-item__label">Délai passation marché</span>
            <span class="recap-item__value">{{ displayData.stepfour?.delaiNeccessairePassationMarche || '—' }}</span>
          </div>
          <div class="recap-item">
            <span class="recap-item__label">Durée exécution marché</span>
            <span class="recap-item__value">{{ displayData.stepfour?.dureePrevisionExecutionMarche || '—' }}</span>
          </div>
          <div class="recap-item">
            <span class="recap-item__label">Échéance de satisfaction</span>
            <span class="recap-item__value recap-item__value--date">
              <span class="material-icons recap-item__date-icon">event</span>
              {{ displayData.stepfour?.echeanceSatisfaction | date:'dd/MM/yyyy' }}
            </span>
          </div>
        </div>
      </div>
    }

    <!-- ── Actions finales ── -->
    <div class="recap-actions">
      <button type="button" class="btn btn-secondary btn-md" (click)="goBack()">
        <span class="material-icons btn-icon btn-icon--left">arrow_back</span>
        Précédent
      </button>
      <button
        type="button"
        class="btn btn-primary btn-md"
        [disabled]="isLoading()"
        (click)="onConfirmSubmit()"
      >
        @if (isLoading()) {
          <span class="btn-spinner"></span>
          Envoi en cours…
        } @else {
          <span class="material-icons btn-icon btn-icon--left">send</span>
          Confirmer et soumettre
        }
      </button>
    </div>

  } @else {

    <!-- État vide -->
    <div class="recap-empty">
      <span class="material-icons recap-empty__icon">folder_open</span>
      <p class="recap-empty__text">Aucune donnée d'activité trouvée.</p>
      <p class="recap-empty__sub">Veuillez commencer par la première étape.</p>
      <button type="button" class="btn btn-primary btn-md" (click)="goToStart()">
        <span class="material-icons btn-icon btn-icon--left">play_arrow</span>
        Commencer
      </button>
    </div>

  }

</div>